import React from "react";

function Header() {
  return (
    <div>
      <h1>Holmenkollen-Riis speidergruppe</h1>
    </div>
  );
}

export default Header;